import React from "react";

import { IFacilityRole } from "api/rpc/2024-04/facilityAdmin/client/admin/admin";

import Input from "components/form/input/Input";
import Card from "components/card/Card";
import { useTranslation } from "react-i18next";
import TextField from "components/form/textField/TextField";
import { useAppSelector } from "hooks/redux";
// import Checkbox from "components/form/checkbox/Checkbox";

interface IRoleDetailProps {
  roleDetails: IFacilityRole;
  inputChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  toggleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  addWage: boolean;
  updateAddWage: () => void;
}
export default function RoleDetailsCard(props: IRoleDetailProps) {
  const { t } = useTranslation();
  const { facilityStore, authStore } = useAppSelector(store => store);

  return (
    <Card title={t("Role details")} titleActions={authStore?.user?.permissions?.admin_view_shift_wages ? [{ content: !props?.addWage ? t("Add wage") : t("Remove wage"), action: () => props?.updateAddWage() }] : undefined}>
      <div className="p-4">
        <div className="pb-4">
          <Input
            id={"title"}
            label={t("Role Name")}
            value={props.roleDetails?.title}
            onChange={e => props.inputChange(e)}
          />
        </div>
        {props?.addWage && authStore?.user?.permissions?.admin_view_shift_wages ? (
          <div className="pb-4">
            <Input
              id={"wage"}
              label={t("Default hourly wage (Optional)")}
              value={props.roleDetails?.wage}
              onChange={e => props.inputChange(e)}
              type="number"
              placeholder="0.00"
              prefix={facilityStore?.facility?.default_currency_symbol ?? "$"}
            />
          </div>
        ) : null}
        <div className="pb-4">
          <TextField
            id={"description"}
            label={t("Description (Optional)")}
            value={props.roleDetails?.description}
            onChange={e => props.inputChange(e)}
          />
        </div>
        {/* <div className="pb-4">
          <Checkbox
            size="medium"
            value={!!props.roleDetails?.default}
            id={"default"}
            label={t("Default Facility Role")}
            onChange={e => props.toggleChange(e)}
          />
        </div> */}
      </div>
    </Card>
  );
}
